import type { FormEvent } from "react";

import { Button, Input } from "@/atoms";
import { strings } from "@/constants";
import { ButtonTypeEnum, ButtonVariantEnum, InputTypeEnum } from "@/enums";

export const ResetPasswordForm = ({
    confirmPassword,
    error,
    isLoading,
    onBackToLogin,
    onChangeConfirmPassword,
    onChangePassword,
    onSubmit,
    password,
}: {
    confirmPassword: string,
    error: string,
    isLoading: boolean,
    onBackToLogin: () => void,
    onChangeConfirmPassword: (value: string) => void,
    onChangePassword: (value: string) => void,
    onSubmit: (event: FormEvent<HTMLFormElement>) => void,
    password: string,
}) => (
    <>
        <form
            className="space-y-5"
            onSubmit={onSubmit}
        >
            <Input
                hasError={!!error}
                label={strings.resetPassword.passwordLabel}
                placeholder={strings.resetPassword.passwordPlaceholder}
                type={InputTypeEnum.PASSWORD}
                value={password}
                isShowPasswordToggle
                onChange={({ target }) => onChangePassword(target.value)}
            />
            <Input
                hasError={!!error}
                label={strings.resetPassword.confirmPasswordLabel}
                placeholder={strings.resetPassword.confirmPasswordPlaceholder}
                type={InputTypeEnum.PASSWORD}
                value={confirmPassword}
                isShowPasswordToggle
                onChange={({ target }) => onChangeConfirmPassword(target.value)}
            />
            <Button
                isLoading={isLoading}
                type={ButtonTypeEnum.SUBMIT}
                isFullWidth
            >
                {strings.resetPassword.submitButton}
            </Button>
        </form>
        <div className="mt-4 text-center">
            <Button
                variant={ButtonVariantEnum.LINK}
                onClick={onBackToLogin}
            >
                {strings.resetPassword.backToLogin}
            </Button>
        </div>
    </>
);
